import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { EncounterPhase, Transcription } from 'src/models';
import { ambientApi } from 'src/services';

export type UseTranscriptionListParams = {
  encounterId: string;
  encounterPhase?: EncounterPhase | null;
  type?: Transcription['type'];
};

export type GetTranscriptionListResponse = {
  transcriptions: Transcription[];
};

export const useGetTranscriptionList = (
  { encounterId, encounterPhase, type }: UseTranscriptionListParams,
  options?: Pick<
    UseQueryOptions<any>,
    'enabled' | 'refetchOnWindowFocus' | 'refetchOnMount'
  >
) => {
  return useQuery({
    ...options,
    queryKey: ['transcriptionList', { encounterId, encounterPhase, type }],
    queryFn: () =>
      ambientApi
        .get<GetTranscriptionListResponse>(`/transcriptions`, {
          params: {
            encounter_id: encounterId,
            encounter_phase: encounterPhase,
            type,
          },
        })
        .then((res) => res.data),
  });
};
